import * as Types from '../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ConvertJobSeekerProfileParsedResumeToIndeedResumeMutationVariables = Types.Exact<{
  input: Types.ConvertJobSeekerProfileParsedResumeToIndeedResumeInput;
}>;


export type ConvertJobSeekerProfileParsedResumeToIndeedResumeMutation = { __typename?: 'Mutation', convertJobSeekerProfileParsedResumeToIndeedResume?: { __typename?: 'ConvertJobSeekerProfileParsedResumeToIndeedResumePayload', resume: { __typename?: 'JobSeekerProfileResume', id: string } } | null };


export const ConvertJobSeekerProfileParsedResumeToIndeedResumeDocument = gql`
    mutation ConvertJobSeekerProfileParsedResumeToIndeedResume($input: ConvertJobSeekerProfileParsedResumeToIndeedResumeInput!) {
  convertJobSeekerProfileParsedResumeToIndeedResume(input: $input) {
    resume {
      id
    }
  }
}
    `;
export type ConvertJobSeekerProfileParsedResumeToIndeedResumeMutationFn = Apollo.MutationFunction<ConvertJobSeekerProfileParsedResumeToIndeedResumeMutation, ConvertJobSeekerProfileParsedResumeToIndeedResumeMutationVariables>;

/**
 * __useConvertJobSeekerProfileParsedResumeToIndeedResumeMutation__
 *
 * To run a mutation, you first call `useConvertJobSeekerProfileParsedResumeToIndeedResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertJobSeekerProfileParsedResumeToIndeedResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertJobSeekerProfileParsedResumeToIndeedResumeMutation, { data, loading, error }] = useConvertJobSeekerProfileParsedResumeToIndeedResumeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConvertJobSeekerProfileParsedResumeToIndeedResumeMutation(baseOptions?: Apollo.MutationHookOptions<ConvertJobSeekerProfileParsedResumeToIndeedResumeMutation, ConvertJobSeekerProfileParsedResumeToIndeedResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertJobSeekerProfileParsedResumeToIndeedResumeMutation, ConvertJobSeekerProfileParsedResumeToIndeedResumeMutationVariables>(ConvertJobSeekerProfileParsedResumeToIndeedResumeDocument, options);
      }
export type ConvertJobSeekerProfileParsedResumeToIndeedResumeMutationHookResult = ReturnType<typeof useConvertJobSeekerProfileParsedResumeToIndeedResumeMutation>;
export type ConvertJobSeekerProfileParsedResumeToIndeedResumeMutationResult = Apollo.MutationResult<ConvertJobSeekerProfileParsedResumeToIndeedResumeMutation>;
export type ConvertJobSeekerProfileParsedResumeToIndeedResumeMutationOptions = Apollo.BaseMutationOptions<ConvertJobSeekerProfileParsedResumeToIndeedResumeMutation, ConvertJobSeekerProfileParsedResumeToIndeedResumeMutationVariables>;